
import { LiveBackgroundContext } from "./liveBackground/LiveBackground";
import LiveAudio from "./liveAudio/LiveAudio";

export default function LiveRouteWrapper({ type, children }) {
    return (
        <LiveBackgroundContext.Provider value={type}>
            <LiveAudio>{children}</LiveAudio>
        </LiveBackgroundContext.Provider>
    );
}
